<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->

<div class="user-info-wrapper" (mouseleave)="isContentDisplayed = false" (mouseenter)="isContentDisplayed = true">
  <div class="user-level-root">
    <img class="user-root-image avatar" [src]="picture">
    <span class="user-root-title">
      My Profile
    </span>
  </div>
  <div *ngIf="isContentDisplayed" class="user-level-content">
    <div><a target="_blank" [href]="url">Manage Profile</a></div>
    <div><a (click)="logout()">Logout</a></div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/user-info/user-info.component.html